// https://twin.github.io/better-file-uploads-with-shrine-direct-uploads/
// https://itnext.io/integrating-dropzone-with-javascript-image-cropper-optimise-image-upload-e22b12ac0d8a
// https://github.com/gorails-screencasts/uppy-and-activestorage-rails/blob/master/app/javascript/packs/application.js
const Uppy = require('@uppy/core')
const UppyDashboard = require('@uppy/dashboard')
const UppyRu = require('@uppy/locales/lib/ru_RU')
const UppyAwsS3 = require('@uppy/aws-s3')
const UppyUrl = require('@uppy/url')
// const UppyXHRUpload = require('@uppy/xhr-upload')
// const UppyFileInput = require('@uppy/file-input')
// const UppyInformer = require('@uppy/informer')
// const UppyProgressBar = require('@uppy/progress-bar')
// import { apiUrl, getByAxios } from "../helpers/axios.js"

import Cropper from 'cropperjs/dist/cropper';
import { UppyDims } from "../helpers/uppy_dims.js"

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["single", "croppergroup", "previewgroup", "cropper", "preview", "uploaded", "delete", "crop"]

  remove_image(event) {
    event.preventDefault()
    this.uploadedTarget.style.display = "none"
    if (this.hasSingleTarget) {
      this.singleTarget.setAttribute('value', '_delete' )
    }
    this.deleteTarget.style.display = "none"
    if (this.hasCroppergroupTarget) {
      this.croppergroupTarget.style.display = "none"
    }

    if (this.hasPreviewgroupTarget) {
      this.previewgroupTarget.style.display = "none"
    }

    if (this.hasCropTarget) {
      this.cropTarget.style.display = "none"
    }
  }
  
  connect() {
    if (this.hasSingleTarget) {
      const trigger = this.appendTrigger()
      this.init_uppy(trigger)
    }
  }

  init_uppy(trigger=null) {

    const uppy = new Uppy({
      // debug: true,
      locale: UppyRu,
      autoProceed: true,
      allowMultipleUploads: false,
      restrictions: {
        // maxFileSize: 15*1024*1024,
        maxNumberOfFiles: 1,
        minNumberOfFiles: null,
        allowedFileTypes: this.singleTarget.dataset.allowedExtensions.split(',').map(x => `image/${x}`)
      }
    })

    uppy.use(UppyAwsS3, {
      companionUrl: '/', // will call the presign endpoint on `/s3/params`
    })

    uppy.use(UppyDashboard, {
      trigger: trigger,
      note: this.singleTarget.dataset.hint,
      closeAfterFinish: true,
    })

    uppy.use(UppyDims, {
      single: this.singleTarget
    })

    uppy.on('thumbnail:generated', (file, preview) => {
      this.fileUrl = preview
    })

    uppy.on('upload-success', (file, response) => {

      // construct uploaded file data in the format that Shrine expects
      this.fileData = {
        id: file.meta['key'].match(/^cache\/(.+)/)[1], // object key without prefix
        storage: 'cache',
        metadata: {
          size: file.size,
          filename: file.name,
          mime_type: file.type,
        }
      }

      this.setInputFileData(this.fileData)
    })

    uppy.on('upload', (result) => {
      this.fileUrl = null
      this.fileData = null
    })

    uppy.on('complete', (result) => {
      if (this.hasCropperTarget) {
        this.setCropper(uppy)
      } else {
        this.setPreview(uppy)
      }
    })

    document.addEventListener('turbolinks:before-visit', () => {
      this.previewTargets.forEach((currentValue, currentIndex, listObj) => {
          currentValue.innerHTML = ""
        }
      )
    })
    
    return uppy
  }

  setInputFileData(data) {
    this.singleTarget.setAttribute('value', JSON.stringify(data) )
  }

  setPreview(uppy) {
    var preview = document.createElement("img")
    preview.setAttribute("src", this.fileUrl)

    this.uploadedTarget.innerHTML = ""
    this.uploadedTarget.appendChild(preview)
    this.uploadedTarget.style.display = 'block'
    this.deleteTarget.style.display = 'inline-block'

    document.addEventListener('turbolinks:before-visit', () => {
      this.uploadedTarget.innerHTML = ""
    })

    uppy.reset()
  }

  init_recropper(e) {
    e.preventDefault()
    let btnEl = e.currentTarget
    btnEl.innerHTML = "<i class='fa fa-spinner fa-spin fa-fw'></i>"
    const uppy = this.init_uppy()
    const imageUrl = this.croppergroupTarget.dataset.targetUrl
    const image_name = imageUrl.split('/').slice(-1)[0].split('?')[0]
    fetch(imageUrl)
    .then((response) => response.blob())
    .then((blob) => {
      uppy.addFile({
        name: image_name,
        type: blob.type,
        data: blob,
        remote: true
      })
      setTimeout(() => btnEl.innerHTML = "<i class='fas fa-crop-alt'></i>", 3000)
    })
  }

  setCropper(uppy=null) {
    if (this.fileData == null) {
      return
    }

    if (this.cropper != null) {
      this.cropper.destroy()
    }

    if (this.hasCropTarget) {
      this.cropTarget.style.display = "none"
    }

    document.addEventListener('turbolinks:before-visit', () => {
      this.cropperTarget.src = ""
      this.cropper.destroy()
    })

    this.cropperTarget.src = this.fileUrl || this.croppergroupTarget.dataset.targetUrl
    this.uploadedTarget.style.display = 'none'
    this.croppergroupTarget.style.display = 'block'
    this.previewgroupTarget.style.display = 'block'

    let _this = this

    this.cropper = new Cropper(this.cropperTarget, {
      viewMode: 1,
      guides: false,
      autoCropArea: 1.0,
      responsive: true,
      background: true,
      aspectRatio: this.cropperTarget.dataset.ratio,
      preview: this.previewTargets,
      crop(event) {
        _this.fileData.metadata.crop = _this.cropper.getData(true)
        _this.fileData.metadata.preview = { width: _this.cropperTarget.width, height: _this.cropperTarget.height }
        _this.setInputFileData(_this.fileData)
        if (uppy) {
          uppy.reset()
        }
      },
    })

    this.deleteTarget.style.display = 'inline-block'
  }

  appendTrigger() {
    if (this.hasSingleTarget) {
      if (document.getElementById(`${this.singleTarget.id}_trigger`)) { return }
    } else {
      return
    }
    let trigger_element = document.createElement('a')
    trigger_element.setAttribute('href', '#')
    trigger_element.setAttribute('id', `${this.singleTarget.id}_trigger`)
    trigger_element.classList.add('btn')
    trigger_element.classList.add('btn-primary')
    trigger_element.classList.add('btn-sm')
    trigger_element.innerHTML = "<i class='fas fa-plus'></i>"
    trigger_element.addEventListener("click", (event) => event.preventDefault())
    this.deleteTarget.parentNode.insertBefore(trigger_element, this.deleteTarget)
    return trigger_element
  }

}
